import { connect } from 'react-redux';
import { setSelectedStore, getStores } from 'Favourites/store/actions';
import appStorage from 'helpers/AppStorage';
import { selectProductIds } from 'Favourites/store/reducers/data/products';

import {
    selectStores,
    selectSelectedStoreId,
} from 'store/reducers/data/stores';

import {
    selectShoppingListView,
} from 'store/reducers/data/shoppingList';

const mapStateToProps = (state) => {
    return {
        stores: selectStores(state),
        selectedStore: selectSelectedStoreId(state, true),
        productCount: selectProductIds(state).length,
        shoppingListView: selectShoppingListView(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getStores: () => {
            dispatch(getStores());
        },
        changeStore: (storeId) => {
            dispatch(setSelectedStore(storeId));
            appStorage('selectedStore', storeId);
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
